export default "__VITE_ASSET__d4a9ed3c__"